import { SelectField } from '~/common/components';
import { SelectErrorIndicator, SelectLoadingIndicator } from '@wyz/ui';
import * as React from 'react';
import { Trans, useI18n } from '~/common/context';
import { useManageVatZones } from '~/connect/api';
type SelectVatZones = {
  name: string;
  label: React.ReactNode;
  required?: boolean;
  isClearable?: boolean;
  readOnly?: boolean;
  countryId?: number;
};
export const SelectVatZones = ({
  isClearable,
  readOnly,
  name,
  label,
  required = false,
  countryId,
}: SelectVatZones) => {
  const vatZones = useManageVatZones({ getAll: { args: { countryId } } });
  const { t } = useI18n();

  return (
    <>
      {(vatZones.isError || !countryId) && (
        <SelectErrorIndicator
          label={label}
          message={
            !countryId ? (
              <Trans i18nKey='app.common.select_field.country_not_select' />
            ) : (
              <Trans i18nKey='app.common.select_field.options_error' />
            )
          }
        />
      )}
      {!vatZones.isSettled && Boolean(countryId) && (
        <SelectLoadingIndicator label={label} />
      )}

      {vatZones.isSuccess && (
        <SelectField
          name={name}
          label={label}
          options={vatZones.data.data.map((vatZone) => ({
            label: t(vatZone.nameKey, {
              defaultValue: vatZone.nameKey, // fallback if key is not found in loco
            }),

            value: vatZone.id,
          }))}
          isClearable={isClearable}
          required={required}
          isDisabled={readOnly}
        />
      )}
    </>
  );
};
